import React from 'react';
import { ProductRecs } from '../../../../../UI/ProductRecs/ProductRecs';
import { AltImages, MainImageSlider } from '../../../../Shared/Content/ProductDetail/ProductAltImages/ProductAltImages';
import ProductLeftRightEspot from '../../../../Shared/Content/ProductDetail/ProductLeftRightEspot/ProductLeftRightEspot';
import { MainImage } from '../../../../Shared/Content/ProductDetail/ProductMainImage/ProductMainImage';
import { Title } from '../../../../Shared/Content/ProductDetail/ProductTitle/ProductTitle';
import { PhotoSwipeZoom, MainImagePhotoSwipeZoom } from '../PhotoSwipeZoom/PhotoSwipeZoom';
import ProductDetail from '../ProductDetail';
import ProductRecommendations from '../../Layouts/Widgets/ProductRecommendations/ProductRecommendations';

export class BundleDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      deviceWidth: '',
      isOpen: false,
      altClicked: false,
      altIndex: 0,
      options: {
        showHideOpacity: true,
        allowPanToNext: true,
        maxSpreadZoom: 3,
        closeOnVerticalDrag: true,
        focus: true,
        index: 0,
      },
    };

    this.zoomIndex = 0;
  }

  componentDidMount() {
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      this.setState({
        deviceWidth: window.outerWidth,
      });

      window.addEventListener(
        'resize',
        _.debounce(
          function () {
            this.setState({
              deviceWidth: window.outerWidth,
            });
          }.bind(this),
          false
        )
      );
    } else {
      // Using window.innerWidth for Tablet. IOS 10 was returning window.outerWidth = 0
      this.setState({
        deviceWidth: window.innerWidth,
      });

      window.addEventListener(
        'resize',
        _.debounce(
          function () {
            this.setState({
              deviceWidth: window.innerWidth,
            });
          }.bind(this),
          false
        )
      );
    }
  }

  openPhotoSwipe = (e) => {
    e.preventDefault();
    this.setState({
      isOpen: true,
      options: {
        index: this.zoomIndex,
        closeOnScroll: false,
      },
    });
  };

  handleClose = () => {
    let index = this.state.options.index;
    let parentThis = this;
    let altWrapper = document.getElementById('product-alt-wrapper');
    if (parentThis.props.contentData.altImages === undefined) {
    } else {
      // if the alt image isn't lazyloaded - click it.
      // if the swipe image's corresponding alt container is lazyloaded, the mutation observer will take care of the click.
      let altImageToUse = parentThis.props.contentData.altImages[index];
      let imageName = altImageToUse.imageName;
      if (document.getElementById(imageName) === null) {
        if (altWrapper !== null) {
          var altToClick = altWrapper.querySelector(`[data-index='${index}']`);
          altToClick.click();
        }
        var observer = new MutationObserver(function (mutations, slickObserver) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              var altButtonToClick = mutation.target.firstElementChild.firstElementChild;
              if (altButtonToClick !== null) {
                altButtonToClick.click();
                slickObserver.disconnect();
              }
            }
          });
        });
        var slideToWatch = altWrapper.querySelector(`[data-index='${index}']`);
        var observerOptions = { childList: true, subtree: true };
        observer.observe(slideToWatch, observerOptions);
      } else {
        document.getElementById(imageName).click();
      }
    }
    this.setState({ isOpen: false });
  };

  updateZoomIndex = (i) => {
    this.zoomIndex = i;
  };

  openPhotoSwipeMain = (e) => {
    let dataKey = parseInt(e.target.getAttribute('data-key'));
    this.setState({
      isOpen: true,
      options: {
        index: dataKey,
        closeOnScroll: false,
      },
    });
  };

  render() {
    return (
      <section className='bundleDisplay' id='BundleDisplay'>
        {this.props.contentData.altImages && this.props.passedAppFunctions.siteFormat == 'tablet' ? (
          <MainImagePhotoSwipeZoom
            isOpen={this.state.isOpen}
            options={this.state.options}
            passedFunctions={this.props.passedFunctions}
            handleClose={this.handleClose}
            contentData={this.props.contentData}
            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
            updateZoomIndex={this.updateZoomIndex}
          />
        ) : (
          <PhotoSwipeZoom
            isOpen={this.state.isOpen}
            options={this.state.options}
            passedFunctions={this.props.passedFunctions}
            handleClose={this.handleClose}
            contentData={this.props.contentData}
            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
            updateZoomIndex={this.updateZoomIndex}
          />
        )}
        <div className={`${this.props.passedFunctions.parentState.imageClickedOn ? 'hidden' : ''}`}>
          <div className='row m-0 d-flex justify-content-between'>
            <div className='col-lg-10 col-xl-10'>
              <div className='row'>
                <div
                  className={`col-sm-4 ${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'col-md-5 p-r-1' : 'col-md-7'}`}
                >
                  <div className='sticky-column'>
                    {this.props.contentData.productLayout == 'BundleDisplay' && (
                      <>
                        <Title
                          contentData={this.props.contentData}
                          passedAppFunctions={this.props.passedAppFunctions}
                        />
                        <span className='item-number block m-b-15'>Item #{this.props.contentData.partNumber}</span>
                      </>
                    )}
                    <div className='row'>
                      {this.state.deviceWidth > 769 && this.props.passedAppFunctions.siteFormat != 'tablet' ? (
                        <div className='col-3'>
                          <AltImages
                            currentAttributeState={this.props.currentAttributeState}
                            contentData={this.props.contentData}
                            passedFunctions={this.props.passedFunctions}
                            passedAppFunctions={this.props.passedAppFunctions}
                            selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                            altClicked={this.props.altClicked}
                          />
                        </div>
                      ) : (
                        ''
                      )}
                      <div className='col-9 p-l-0 bundleCol'>
                        {this.props.contentData.altImages && this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                          <MainImageSlider
                            contentData={this.props.contentData}
                            passedFunctions={this.props.passedFunctions}
                            passedAppFunctions={this.props.passedAppFunctions}
                            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                            openPhotoSwipeMain={this.openPhotoSwipeMain}
                            altClicked={this.state.altClicked}
                            altIndex={this.state.altIndex}
                          />
                        ) : (
                          <MainImage
                            passedFunctions={this.props.passedFunctions}
                            passedAppFunctions={this.props.passedAppFunctions}
                            contentData={this.props.contentData}
                            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                            openPhotoSwipe={this.openPhotoSwipe}
                          />
                        )}
                        {this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                          <span className='tapToZoom'>Tap image to zoom</span>
                        ) : (
                          ''
                        )}
                        {this.state.deviceWidth < 769 || this.props.passedAppFunctions.siteFormat == 'tablet' ? (
                          //Alts displayed below MainImage for tablet.
                          <AltImages
                            currentAttributeState={this.props.currentAttributeState}
                            contentData={this.props.contentData}
                            passedFunctions={this.props.passedFunctions}
                            vertical={false}
                            passedAppFunctions={this.props.passedAppFunctions}
                            selectedAttributeValue={this.props.passedFunctions.parentState.selectedAttributeValue}
                            selectedMainImg={this.props.passedFunctions.parentState.selectedMainImg}
                            altClicked={this.props.altClicked}
                          />
                        ) : (
                          ''
                        )}
                        <ProductLeftRightEspot contentData={this.props.contentData} />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`col-sm-4 ${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'col-md-7 p-l-0' : 'col-md-5'}`}
                >
                  {this.props.contentData.components.map((component, index) => (
                    <div
                      key={component.productId}
                      className={`${index == 0 ? 'bundleDisplay__div--outfitComponentFirst' : ''} bundleDisplay__div--outfitComponent`}
                    >
                      <ProductDetail
                        contentData={component}
                        parentPersonalization={this.props.contentData.personalization}
                        parentProductLayout={this.props.contentData.productLayout}
                        passedFunctions={this.props.passedFunctions}
                        passedAppFunctions={this.props.passedAppFunctions}
                        forceBundleRender={this.props.passedFunctions.forceBundleRender}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
              <div className='col-lg-2 col-xl-2'>
                <div className='productRecsColumn'>
                  <ProductRecs
                    zoneName='PDPZ1'
                    contentData={this.props.contentData}
                    vertical={true}
                    passedAppFunctions={this.props.passedAppFunctions}
                  />
                </div>
              </div>
            ) : (
              <div className='productRecsColumn'>
                <ProductRecs
                  zoneName='PDPZ1'
                  contentData={this.props.contentData}
                  vertical={true}
                  passedAppFunctions={this.props.passedAppFunctions}
                />
              </div>
            )}
          </div>
          <div className='recentlyViewedContainer'>
            <ProductRecommendations
              widgetData={{
                zone: 'RecentlyViewed',
                scrollable: true,
                rows: 1,
                productsPerRow: 6,
                showProductTitle: true,
                title: 'Recently Viewed',
              }}
              passedAppFunctions={this.props.passedAppFunctions}
              contentData={this.props.contentData}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default BundleDisplay;
